import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../styles/Header.css';

function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('');
  const [shouldScrollToAbout, setShouldScrollToAbout] = useState(false);
  const [isProgrammaticScroll, setIsProgrammaticScroll] = useState(false);
  
  const isActive = (path) => {
    if (path === '/about' && location.pathname === '/') {
      return activeSection === 'about';
    }
    if (path === '/' && location.pathname === '/' && activeSection === 'about') {
      return false;
    }
    if (path === '/faq') {
      return location.pathname === '/faq'
        || location.pathname.startsWith('/faq/')
        || location.pathname === '/learn'
        || location.pathname.startsWith('/learn/');
    }
    return location.pathname === path;
  };

  useEffect(() => {
    const handleScroll = () => {
      if (isProgrammaticScroll) {
        return;
      }
      
      if (location.pathname === '/') {
        const aboutSection = document.querySelector('.about');
        const blogCtaSection = document.querySelector('.blog-cta');
        
        if (aboutSection) {
          const rect = aboutSection.getBoundingClientRect();
          const blogCtaRect = blogCtaSection ? blogCtaSection.getBoundingClientRect() : null;
          const headerHeight = 80;
          
          const aboutVisible = rect.top <= headerHeight + 100 && rect.bottom >= headerHeight + 100;
          const blogCtaVisible = blogCtaRect && blogCtaRect.top <= headerHeight + 100 && blogCtaRect.bottom >= headerHeight + 100;
          
          setActiveSection((aboutVisible || blogCtaVisible) ? 'about' : '');
        }
      } else {
        setActiveSection('');
      }
    };

    let ticking = false;
    const throttledHandleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', throttledHandleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', throttledHandleScroll);
  }, [location.pathname, isProgrammaticScroll]);

  useEffect(() => {
    if (shouldScrollToAbout && location.pathname === '/') {
      const aboutSection = document.querySelector('.about');
      if (aboutSection) {
        setIsProgrammaticScroll(true);
        setActiveSection('about');
        
        aboutSection.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
        
        setTimeout(() => {
          setIsProgrammaticScroll(false);
        }, 1000);
        
        setShouldScrollToAbout(false);
      }
    }
  }, [location.pathname, shouldScrollToAbout]);

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <Link to="/">
            <img src="/jblassets/logo-jb-only.svg" alt="" className="logo-img" />
            <span className="logo-text">Jones & Booth Law</span>
          </Link>
        </div>
        <div className="nav-section">
          <nav className="nav">
            <Link 
              to="/" 
              className={isActive('/') ? 'active' : ''}
              onClick={(e) => {
                if (location.pathname === '/') {
                  e.preventDefault();
                  window.scrollTo({ 
                    top: 0,
                    behavior: 'smooth'
                  });
                } else if (location.pathname === '/about') {
                  e.preventDefault();
                  navigate('/');
                }
              }}
            >
              Home
              {isActive('/') && <span className="active-indicator">●</span>}
            </Link>
            <Link to="/about" className={isActive('/about') ? 'active' : ''}>
              About
              {isActive('/about') && <span className="active-indicator">●</span>}
            </Link>
            <Link to="/blog" className={isActive('/blog') ? 'active' : ''}>
              Blog
              {isActive('/blog') && <span className="active-indicator">●</span>}
            </Link>
            <Link to="/faq" className={isActive('/faq') ? 'active' : ''}>
              FAQ
              {isActive('/faq') && <span className="active-indicator">●</span>}
            </Link>
            <Link to="/qualify" className={isActive('/qualify') ? 'active' : ''}>
              Contact
              {isActive('/qualify') && <span className="active-indicator">●</span>}
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
